import { FormControl, FormGroup, NgForm, Validators, AbstractControl } from '@angular/forms';

export class FormUtil {
	static hasError(control: FormControl) {
		return !!(control && control.invalid && (control.dirty || control.touched) && Object.keys(control.errors).length > 0);
	}

	static hasErrorsOtherThanRequired(form: FormGroup) {
		const otherThanRequired = Object.values(form.controls).filter((q) => q.errors && !q.hasError('required'));
		return otherThanRequired.length > 0;
	}

	static markAsInvalid(form: FormGroup) {
		form.setErrors({ invalid: true });
	}

	static markAsTouched(form: FormGroup) {
		form.markAsTouched();
		// these loops shouldn't be necessary? -AM
		Object.keys(form.controls).forEach((key) => {
			const control = form.controls[key] as FormControl;
			if (control) {
				control.markAsTouched();
			}
		});
	}

	static markAsUntouched(form: FormGroup) {
		form.markAsPristine();
		form.markAsUntouched();
		Object.keys(form.controls).forEach((key) => {
			const control = form.controls[key] as FormControl;
			if (control) {
				control.markAsUntouched();
				control.markAsPristine();
			}
		});
	}

	static markAsPristine(form: FormGroup) {
		form.markAsPristine();
		Object.keys(form.controls).forEach((key) => {
			const control = form.controls[key] as FormControl;
			if (control) {
				control.markAsPristine();
			}
		});
	}

	static setRequired(control: AbstractControl, isRequired: boolean) {
		if (!isRequired) {
			control.setValue('');
		}
		control.setValidators(isRequired ? [Validators.required] : null);
		control.updateValueAndValidity({ onlySelf: true });
	}

	static validateEmail(email: FormControl, confirm: FormControl) {
		const emailErrors = email.errors ? email.errors : {};
		const confirmErrors = confirm.errors ? confirm.errors : {};

		// lets only validate if other errors don't exist
		if (
			email.value !== confirm.value &&
			email.touched &&
			confirm.touched &&
			Object.keys(emailErrors).length === 0 &&
			Object.keys(confirmErrors).length === 0
		) {
			emailErrors.equal = true;
			email.setErrors(emailErrors);
			confirmErrors.equal = true;
			confirm.setErrors(confirmErrors);
		} else {
			delete emailErrors.equal;
			delete confirmErrors.equal;
			email.setErrors(Object.keys(emailErrors).length === 0 ? null : emailErrors);
			confirm.setErrors(Object.keys(confirmErrors).length === 0 ? null : confirmErrors);
		}
	}

	static validateRange(control: FormControl, min: number, max: number) {
		const rangeErrors = control.errors ? control.errors : {};
		// lets only validate if other errors don't exist
		if (!(+control.value >= min && +control.value <= max) && Object.keys(rangeErrors).length === 0) {
			rangeErrors.range = true;
			control.setErrors(rangeErrors);
		} else {
			delete rangeErrors.range;
			control.setErrors(Object.keys(rangeErrors).length === 0 ? null : rangeErrors);
		}
		control.markAsTouched();
	}

	static getForm(ngForm: NgForm) {
		return ngForm;
	}
}
